import { render, staticRenderFns } from "./newComplainWorkOrder.vue?vue&type=template&id=1c07765e"
import script from "./newComplainWorkOrder.vue?vue&type=script&lang=js"
export * from "./newComplainWorkOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports